import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.NOT_AVAILABLE_MEAL_ORDER_REPORT_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.NOT_AVAILABLE_MEAL_ORDER_REPORT_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const notavailableMealOrderReport = ({ params }) => {
  return async (dispatch) => {
    dispatch({ type: CONST.NOT_AVAILABLE_MEAL_ORDER_REPORT_REQUEST });

    axios.get('/reports/not-available-order-meal', { params }).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
